import React from 'react';
import { Link } from 'react-router';
import { GiaiQuyetDonThu } from 'api';
import { Radio, RadioGroup } from '@blueprintjs/core';
import { header } from 'constants/table';
import DataTable from 'components/data-table';
import moment from 'moment';
import {ListSearch} from 'modules/giai-quyet-don/subView';
import RowItemTDTHGQD from './datatable/RowItemTDTHGQD.jsx';
import {MasterLayout} from 'layout';
import {FormSort} from 'modules/reception/form-sort';

class TheoDoiThucHienGQD extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      vaiTro: '',
      trangThaiGiaiQuyetDon: 'DANG_GIAI_QUYET',
      advanceSearch: false,
      tuKhoa: '',
      maDon: '',
      nguonDon: '',
      phanLoaiDon: '',
      tiepNhanTuNgay: '',
      tiepNhanDenNgay: '',
      tinhTrangGiaiQuyet: '',
      ketQuaGiaiQuyet: '',
      phongBanXuLyXLD: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      sortBy: 'ngayTiepNhan,desc',
      data: [],
      spSearch: false,
      search: false,
      tableLoading: false,
      searchLoading: false
    };
  }

  componentDidMount() {
    let data = localStorage.getItem('tdthGQD') ? JSON.parse(localStorage.getItem('tdthGQD')) : {};
    this.state.trangThaiGiaiQuyetDon = data.trangThaiDon || 'DANG_GIAI_QUYET';
    this.state.advanceSearch = data.advanceSearch || false;
    this.state.pageData.number = data.page || 0;
    this.state.pageData.size = data.size || 10;
    this.state.tuKhoa = data.hoTen || '';
    if (this.state.advanceSearch) {
      this.state.isSaveTemp = data.isSaveTemp;
      this.state.nguonDon = data.nguonDon || '';
      this.state.maDon = data.maDon || '';
      this.state.phanLoaiDon = data.phanLoaiDon || '';
      this.state.tinhTrangGiaiQuyet =  data.trangThaiDonToanHT || '';
      this.state.ketQuaGiaiQuyet = data.ketQuaToanHT || '';
      this.state.tiepNhanTuNgay = data.tiepNhanTuNgay ? new Date(data.tiepNhanTuNgay) : '';
      this.state.tiepNhanDenNgay = data.tiepNhanDenNgay ? new Date(data.tiepNhanDenNgay) : '';
    }
    this.setState({...this.state});
    this.getListData()
  }

  openSearchForm() {
    this.state.advanceSearch = true;
    this.setState({...this.state});
    let data = localStorage.getItem('tdthGQD') ? JSON.parse(localStorage.getItem('tdthGQD')) : {};
    data.advanceSearch = true;
    localStorage.setItem('tdthGQD', JSON.stringify(data));
  }

  closeSearchForm() {
    this.state.advanceSearch = false;
    this.setState({...this.state});
    let data = localStorage.getItem('tdthGQD') ? JSON.parse(localStorage.getItem('tdthGQD')) : {};
    data.advanceSearch = false;
    localStorage.setItem('tdthGQD', JSON.stringify(data));
  }

  handleSearch(searchData, e) {
    // Dung ung dung neu ngay nhap khong hop le
    if ([searchData.tiepNhanTuNgay, searchData.tiepNhanDenNgay].indexOf('INVALID') != -1) {
      return;
    }
    this.state.search = true;
    let newData = {
      ...this.state,
      ...searchData
    }
    this.state = newData;
    this.state.pageData = {
      number: 0,
      size: 10,
      totalElements: 0
    };
    this.setState({...this.state});

    this.getListData();
  }

  getListData() {
    let params = {
      trangThaiDon: this.state.trangThaiGiaiQuyetDon,
      thanhLapDon: true,
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: this.state.sortBy
    }

    this.setState({
      searching: true,
      tableLoading: true,
      searchLoading: true
    });

    if (this.state.isSaveTemp) {
      params.isSaveTemp = this.state.isSaveTemp;
    }

    if (this.state.tuKhoa) {
      params.hoTen = this.state.tuKhoa;
    }
    if (this.state.advanceSearch) {
      if (this.state.maDon) {
        params.maDon = this.state.maDon;
      }

      if (this.state.phanLoaiDon) {
        params.phanLoaiDon = this.state.phanLoaiDon;
      }

      if (this.state.nguonDon) {
        params.nguonDon = this.state.nguonDon;
      }

      if (this.state.tinhTrangGiaiQuyet) {
        params.trangThaiDonToanHT = this.state.tinhTrangGiaiQuyet;
      }

      if (this.state.ketQuaGiaiQuyet) {
        params.ketQuaToanHT = this.state.ketQuaGiaiQuyet;
      }

      if (this.state.tiepNhanTuNgay) {
        params.tiepNhanTuNgay = moment(this.state.tiepNhanTuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }

      if (this.state.tiepNhanDenNgay) {
        params.tiepNhanDenNgay = moment(this.state.tiepNhanDenNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
    }
    localStorage.setItem('tdthGQD', JSON.stringify({...params, advanceSearch: this.state.advanceSearch}));
    GiaiQuyetDonThu.actions.getListTheoDoiThucHienGQD.request(params).then(res => {
      if (this.refs.listGQD) {
        if (res.data._embedded) {
          this.setState({
            data: res.data._embedded.dons,
            pageData: res.data.page
          });
        } else {
          this.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            }
          });
        }
        this.setState({
          tableLoading: false,
          searchLoading: false,
          searching: false,
          search: false
        });
      }
    });
  }

  handleChange(name, e) {
    this.setState({
      [e.target.name] : e.target.value
    });
    if (name === 'sortBy') {
      this.handleSort(e.target.value);
    }
  }

  handleSort(sortBy) {
    let params = {
      trangThaiDon: this.state.trangThaiGiaiQuyetDon,
      thanhLapDon: true,
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: sortBy
    };

    this.setState({
      searching: true,
      tableLoading: true,
      searchLoading: true
    });
    if (this.state.isSaveTemp) {
      params.isSaveTemp = this.state.isSaveTemp;
    }

    if (this.state.tuKhoa) {
      params.hoTen = this.state.tuKhoa;
    }
    if (this.state.advanceSearch) {
      if (this.state.maDon) {
        params.maDon = this.state.maDon;
      }

      if (this.state.phanLoaiDon) {
        params.phanLoaiDon = this.state.phanLoaiDon;
      }

      if (this.state.nguonDon) {
        params.nguonDon = this.state.nguonDon;
      }

      if (this.state.tinhTrangGiaiQuyet) {
        params.trangThaiDonToanHT = this.state.tinhTrangGiaiQuyet;
      }

      if (this.state.ketQuaGiaiQuyet) {
        params.ketQuaToanHT = this.state.ketQuaGiaiQuyet;
      }

      if (this.state.tiepNhanTuNgay) {
        params.tiepNhanTuNgay = moment(this.state.tiepNhanTuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }

      if (this.state.tiepNhanDenNgay) {
        params.tiepNhanDenNgay = moment(this.state.tiepNhanDenNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
    }
    localStorage.setItem('tdthGQD', JSON.stringify({...params, advanceSearch: this.state.advanceSearch}));
    GiaiQuyetDonThu.actions.getListTheoDoiThucHienGQD.request(params).then(res => {
      if (this.refs.listGQD) {
        if (res.data._embedded) {
          this.setState({
            data: res.data._embedded.dons,
            pageData: res.data.page
          });
        } else {
          this.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            }
          });
        }
        this.setState({
          tableLoading: false,
          searchLoading: false,
          searching: false,
          search: false
        });
      }
    });
  }

  handleChangeTrangThaiGiaiQuyet(e) {
    if (e.target.name == 'trangThaiGiaiQuyetDon') {
      localStorage.setItem('gqd.currentTab', e.target.value);
      this.setState({
        [e.target.name]: e.target.value,
        advanceSearch: false,
        pageData: {
          number: 0,
          size: 10,
          totalElements: 0
        }
      }, () => {
        this.getListData();
      });
      this.refs.listSearch.resetData();
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData();
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData();
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.data !== this.props.data) {
      this.setState({data: nextProps.data});
    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
      <div ref="listGQD">
        <div className="center reception-container gqd-container">
          <div className="top-content">
            <div className="left-content">
              <RadioGroup
                name={`trangThaiGiaiQuyetDon`}
                className="radio-gender"
                onChange={this.handleChangeTrangThaiGiaiQuyet.bind(this)}
                selectedValue={this.state.trangThaiGiaiQuyetDon}>
                <Radio label="CÔNG VIỆC ĐANG THEO DÕI" value="DANG_GIAI_QUYET" className="pt-large txt-bold radio-header" />
                <Radio label="CÔNG VIỆC ĐÃ HOÀN THÀNH" value="DA_GIAI_QUYET" className="pt-large txt-bold radio-header" />
              </RadioGroup>
            </div>
          </div>
          <div className="bottom-content">
            <div className={ this.state.advanceSearch ? 'search-container super-search' : 'search-container' }>
              <ListSearch onStatus={this.state.trangThaiGiaiQuyetDon} ref="listSearch" advanceSearch={this.state.advanceSearch} onCancel={ this.closeSearchForm.bind(this) } handleSearch={ this.handleSearch.bind(this) } disabled={ this.state.searching } search={ this.state.search } cookieName="tdthGQD"/>
              <Link className="rearch-text" onClick={ this.openSearchForm.bind(this) }><i className="tt tt-super-search"></i>Tìm kiếm nâng cao</Link>
            </div>
            <FormSort
              type='theoDoiThucHien'
              pageDetail={this.state.pageData}
              selectedValue={this.state.sortBy}
              onChange={ this.handleChange.bind(this, 'sortBy') }
            />
            <DataTable
              header={header.giaiQuyetDon.listGQD}
              dataList={this.state.data}
              pageData={this.state.pageData}
              parent={this}
              hideButtonExport
              search={this.state.search}
              tableLoading={this.state.tableLoading}>
                <RowItemTDTHGQD type={this.state.trangThaiGiaiQuyetDon} getListData={this.getListData.bind(this)}/>
              </DataTable>
          </div>
        </div>
      </div>
      </MasterLayout>
    );
  }
}

export default TheoDoiThucHienGQD;



// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/TheoDoiThucHienGQD.jsx